/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmbassadorWhitepaperDto } from '../../models/ambassador-whitepaper-dto';

export interface GetAllAmbassadors$Params {
}

export function getAllAmbassadors(http: HttpClient, rootUrl: string, params?: GetAllAmbassadors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmbassadorWhitepaperDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllAmbassadors.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmbassadorWhitepaperDto>>;
    })
  );
}

getAllAmbassadors.PATH = '/api/ambassadors';
